import React from 'react';
import { Pagination } from 'antd';
import type { PaginationProps } from 'antd';
import { Left, Right } from 'patternx-svg';
import './index.less';

const PtxPagination: React.FC<PaginationProps> = (props) => {
  const itemRender: PaginationProps['itemRender'] = (_, type, originalElement) => {
    if (type === 'prev') {
      return <Left size={16} />;
    }
    if (type === 'next') {
      return <Right size={16} />;
    }
    return originalElement;
  };

  return (
    <Pagination
      className="ptxPagination"
      showTotal={(total) => `共 ${total} 条`}
      itemRender={itemRender}
      {...props}
    />
  );
};

export default PtxPagination;
